import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { initServiceWorkerAutoReload } from "./lib/sw-update";
import { SITE_MODE, demoRedirectTarget } from "./lib/site-mode";

// MUST run before the React tree mounts so the global error handlers are in
// place when the first render throws. No-op when VITE_SENTRY_DSN is unset.
initSentry();

initServiceWorkerAutoReload();

// An old /demo link on the real app goes to the demo site, before anything
// renders: the coming-soon gate would otherwise stand in front of it, and a
// returning visitor's service worker answers /demo without asking the
// server, so a server-side redirect alone would not reach them.
const toDemo = demoRedirectTarget(SITE_MODE, window.location.pathname, window.location.search);
if (toDemo) window.location.replace(toDemo);
else createRoot(document.getElementById("root")!).render(<App />);
